// Brings the selected variant's photo to the front of the product gallery.
// The product-form partial re-renders on every variant change and carries the
// variant's featured media id in [data-variant-media-id]; this watches for that
// and moves the matching gallery item into first position.
class VariantMedia extends HTMLElement {
  connectedCallback() {
    this.gallery = document.querySelector('[data-product-gallery]');
    this.form = document.querySelector('[data-product-form]');
    if (!this.gallery || !this.form) return;

    this.lastId = null;
    this.sync(false);
    this.observer = new MutationObserver(() => this.sync(true));
    this.observer.observe(this.form, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  sync(fromChange) {
    const marker = this.form.querySelector('[data-variant-media-id]');
    const mediaId = marker?.dataset.variantMediaId;
    if (!mediaId || mediaId === this.lastId) return;
    this.lastId = mediaId;

    const item = this.gallery.querySelector(`[data-media-id="${CSS.escape(mediaId)}"]`);
    if (!item) return;

    if (this.gallery.firstElementChild !== item) {
      this.gallery.prepend(item);
    }

    if (!fromChange) return;
    // Mobile: the gallery is a horizontal scroller, so return it to the start.
    this.gallery.scrollTo({ left: 0, behavior: 'smooth' });
    // Desktop: make sure the photo is in view if the shopper has scrolled past it.
    const top = this.gallery.getBoundingClientRect().top;
    if (top < 0) {
      this.gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

if (!customElements.get('s-variant-media')) {
  customElements.define('s-variant-media', VariantMedia);
}
